import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { catchError, switchMap, tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { DynamicDialogService } from "../Customer/dynamic-dialog/dynamic-dialog.service";
import { HttpServiceAccount } from "../Authorization/http/http.service_Account";
import { User } from "src/classes/Automation/UserApp";
import { PersonIncoming } from "src/classes/Authorization/BusinessRole";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    AutomationURLs: string[] = [
        environment.urlserv + "/Home/PostSMSAppointment",
        environment.urlserv + "/Home/PostSMSAppointment4Send",
        environment.urlserv + "/Home/GetBalanceSMS",
        environment.urlserv + "/Home/PostSMSBulk4Send",
        environment.urlserv + "/Home/Login",
        environment.urlserv + "/Home/IsTokenValid",
        environment.urlserv + "/Home/GetDataBodiesForCase",
        environment.urlserv + "/Home/GetDataTemplates",
        environment.urlserv + "/Home/GetDataAdminPanel",
        environment.urlserv + "/Home/GetDataTags",
        environment.urlserv + "/Home/PostMessage4Help",
        environment.urlserv + "/Home/SetDataTemplates",
        environment.urlserv + "/Home/SetDataAdminPanel",
        environment.urlserv + "/Home/GetDataReportMain",
        environment.urlserv + "/Home/GetDataReportDetail",
        environment.urlserv + "/Home/GetDataReportMain",
        environment.urlserv + '/Home/SendSMSClient',
        environment.urlservbeautech + "/api/Account"
    ];

    public personincoming: PersonIncoming = new PersonIncoming();

    isFirstInit: boolean = true;

    constructor(
        private router: Router,
        private dynamicDialogService: DynamicDialogService,
        private httpServiceAccount: HttpServiceAccount
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const userToken = sessionStorage.getItem("token");
        // If the request is not in the list of requests that do not need a token, then add the token to the request
        if (!this.AutomationURLs.includes(request.url) && !request.url.includes("amazonaws")
        ) {
            const modifiedReq = request.clone({
                headers: request.headers.set("Authorization", `Bearer ${userToken}`),
            });
            return next.handle(modifiedReq)
                .pipe(
                    // If the response is successful, then the first initialization is completed
                    tap((event: HttpResponse<any> | { type: number }) => {
                        if (event instanceof HttpResponse) {
                            this.isFirstInit = false;
                        }
                    }),
                    catchError((error: any) => {
                        // If the error is 401 and the first initialization is completed, then try to log in
                        if (error.status == 401) {
                            if (!this.isFirstInit) {
                                this.personincoming.login = sessionStorage.getItem("email");
                                this.personincoming.password = sessionStorage.getItem("password");

                                return this.httpServiceAccount.postDataLoginBeautech(this.personincoming)
                                    .pipe(switchMap((res: User) => {
                                        sessionStorage.setItem("token", res.token);

                                        console.log({ token: res.token }, new Date().toTimeString());

                                        const modReq = request.clone({
                                            headers: request.headers.set("Authorization", `Bearer ${res.token}`),
                                        });

                                        // Retry the same call
                                        return next.handle(modReq);
                                    }));
                            }
                            else {
                                this.dynamicDialogService.closeDialog();
                                this.router.navigate(["login"], { state: { tokenExpired: true } });
                            }
                            return throwError(error);
                        }
                    }));
        }
        else {
            return next.handle(request);
        }
    }
}